import React, {ReactNode} from 'react';
import {Button, ButtonOwnProps, IconButton, Tooltip, useMediaQuery, useTheme} from '@mui/material';

type Props = {
   label: string;
   icon: ReactNode;
   onClick?: () => void;
   color?: ButtonOwnProps['color'];
   variant?: ButtonOwnProps['variant'];
   disabled?: boolean;
   tooltip?: string;
};

export const ResponsiveActionButton = ({
   label,
   icon,
   onClick,
   color = 'primary',
   variant = 'contained',
   disabled,
   tooltip,
}: Props) => {
   const theme = useTheme();
   const isMobile = useMediaQuery(theme.breakpoints.down('md'));

   const content = isMobile ? (
      <IconButton color={color} onClick={onClick} disabled={disabled} aria-label={label}>
         {icon}
      </IconButton>
   ) : (
      <Button
         variant={variant}
         color={color}
         startIcon={icon}
         onClick={onClick}
         disabled={disabled}
      >
         {label}
      </Button>
   );

   if (!tooltip) return content;

   return (
      <Tooltip title={tooltip}>
         <span>{content}</span>
      </Tooltip>
   );
};
